import { Map } from 'immutable';
// immutable has many good use cases. Read more at: https://immutable-js.github.io/immutable-js/
import { ADD_ORG, UPDATE_ORG, DELETE_ORG, POPULATE_ORGS, RETRIEVE_ORG } from '@constants/actions';
import { Organisation } from '@interfaces/organisation.interface';

const initialState = Map({
  orgList: [],
  totalCount: 0,
  selectedOrg: Map({})
});

const Organisations = (state = initialState, action: any) => {
  const actionPayload = action.payload;
  switch(action.type) {
    case POPULATE_ORGS:
      return state.set('orgList', actionPayload.orgs)
        .set('totalCount', actionPayload.totalCount);
    case RETRIEVE_ORG:
      return state.set('selectedOrg', actionPayload ? actionPayload.org : null);
    default:
      return state;
  }
};

export default Organisations;